import { render } from "./ModalAddInfoSaleChannels.vue?vue&type=template&id=762f2b09&scoped=true"
import script from "./ModalAddInfoSaleChannels.vue?vue&type=script&lang=js"
export * from "./ModalAddInfoSaleChannels.vue?vue&type=script&lang=js"

import "./ModalAddInfoSaleChannels.vue?vue&type=style&index=0&id=762f2b09&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762f2b09"]])

export default __exports__